import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ReactComponent as BoxIllustration } from './box-illustration.svg';
import MembershipBannerButton from './MembershipBannerButton';

import { I18n } from '../components/translate';

import styles from './ContentMembershipBanner.module.scss';

const ContentMembershipBanner = ({ className }) => {
  return (
    <div
      className={classnames(
        className,
        '_border _border-gray-200 _rounded-lg _p-5 _d-flex \
        _justify-content-md-between _align-items-md-center _flex-column _flex-md-row'
      )}
    >
      <div className="_mr-md-5 _mb-5 _mb-md-0">
        <BoxIllustration className={styles.boxIllustration} aria-hidden />
      </div>
      <div className="_text-2 _text-gray-600 _mb-5 _mb-md-0 _mr-md-4">
        <I18n html label="membership_banner.content.description" />
      </div>
      <MembershipBannerButton className="_text-2 _align-self-start _align-self-md-center" />
    </div>
  );
};

ContentMembershipBanner.propTypes = {
  className: PropTypes.string
};

ContentMembershipBanner.defaultProps = {
  className: ''
};

export default ContentMembershipBanner;
